import React, { FC, memo } from 'react';

import { StyledMiscImages } from './styles';

import img1 from '@assets/imgs/mocks/screenshot_ban_en.jpg';
import img2 from '@assets/imgs/mocks/screenshot_ban_kk.jpg';
import img3 from '@assets/imgs/mocks/screenshot_ban_ru.jpg';
import img4 from '@assets/imgs/mocks/screenshot_ban_tr.jpg';

import img5 from '@assets/imgs/mocks/dating-frame-1.jpg';
import img6 from '@assets/imgs/mocks/dating-frame-2.jpg';
import img7 from '@assets/imgs/mocks/dating-frame-3.jpg';
import img8 from '@assets/imgs/mocks/dating-frame-4.jpg';

import img9 from '@assets/imgs/mocks/screenshot-english.jpg';
import img10 from '@assets/imgs/mocks/screenshot-russian.jpg';
import img11 from '@assets/imgs/mocks/screenshot-kazakh.jpg';
import img12 from '@assets/imgs/mocks/screenshot-turkish.jpg';

import img13 from '@assets/imgs/mocks/courses-books-ru.jpg';
import img14 from '@assets/imgs/mocks/courses-books-en.jpg';
import img15 from '@assets/imgs/mocks/courses-books-kk.jpg';
import img16 from '@assets/imgs/mocks/courses-books-tr.jpg';

export interface MiscImagesProps {
  className?: string;
  style?: React.CSSProperties;
}

const _MiscImages: FC<MiscImagesProps> = () => {
  return (
    <StyledMiscImages>
      <a href={img1} target="_blank" rel="noopener noreferrer">
        screenshot_ban_en
      </a>
      <a href={img2} target="_blank" rel="noopener noreferrer">
        screenshot_ban_kk
      </a>
      <a href={img3} target="_blank" rel="noopener noreferrer">
        screenshot_ban_ru
      </a>
      <a href={img4} target="_blank" rel="noopener noreferrer">
        screenshot_ban_tr
      </a>
      <a href={img5} target="_blank" rel="noopener noreferrer">
        dating-frame-1
      </a>
      <a href={img6} target="_blank" rel="noopener noreferrer">
        dating-frame-2
      </a>
      <a href={img7} target="_blank" rel="noopener noreferrer">
        dating-frame-3
      </a>
      <a href={img8} target="_blank" rel="noopener noreferrer">
        dating-frame-4
      </a>
      <a href={img9} target="_blank" rel="noopener noreferrer">
        screenshot-english
      </a>
      <a href={img10} target="_blank" rel="noopener noreferrer">
        screenshot-russian
      </a>
      <a href={img11} target="_blank" rel="noopener noreferrer">
        screenshot-kazakh
      </a>
      <a href={img12} target="_blank" rel="noopener noreferrer">
        screenshot-turkish
      </a>
      <a href={img13} target="_blank" rel="noopener noreferrer">
        courses-books-ru
      </a>
      <a href={img14} target="_blank" rel="noopener noreferrer">
        courses-books-en
      </a>
      <a href={img15} target="_blank" rel="noopener noreferrer">
        courses-books-kk
      </a>
      <a href={img16} target="_blank" rel="noopener noreferrer">
        courses-books-tr
      </a>
    </StyledMiscImages>
  );
};

export const MiscImages = memo(_MiscImages);
